var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _path67, _g2, _path68, _path69, _path70, _g3, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _g4, _path84, _g5, _path85, _path86, _path87, _path88, _g6, _path89, _g7, _path90, _path91, _path92, _g8, _path93, _path94, _path95, _g9, _path96, _path97, _path98, _path99, _g0, _path100, _path101, _path102, _g1, _path103, _path104, _path105, _g10, _path106, _g11, _path107, _path108, _path109, _g12, _path110, _g13, _path111, _path112, _path113, _g14, _path114, _g15, _path115, _path116, _path117, _g16, _path118, _g17, _path119, _path120, _path121, _g18, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g19, _path130, _g20, _path131, _path132, _path133, _g21, _path134, _g22, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _g23, _path151, _g24, _path152, _path153, _path154, _g25, _path155, _g26, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.711 263.756C442.71 237.194 436.527 209.45 428.248 184.722C415.951 147.991 392.078 110.326 351.878 101.632C328.695 96.618 305.105 101.991 285.233 114.551C266.118 126.632 251.21 142.237 227.718 145.26C203.95 148.319 179.561 147.087 155.666 147.087C94.239 147.087 44.386 211.621 56.849 278.844C69.312 346.066 128.068 392.674 177.923 392.674C222.721 392.674 259.577 365.796 302.127 358.581C323.228 355.003 344.417 359.237 365.296 353.876C389.566 347.644 412.39 332.768 425.835 311.235C434.999 296.56 439.459 280.39 440.711 263.756Z",
    fill: "#3AF2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M440.711 263.756C442.71 237.194 436.527 209.45 428.248 184.722C415.951 147.991 392.078 110.326 351.878 101.632C328.695 96.618 305.105 101.991 285.233 114.551C266.118 126.632 251.21 142.237 227.718 145.26C203.95 148.319 179.561 147.087 155.666 147.087C94.239 147.087 44.386 211.621 56.849 278.844C69.312 346.066 128.068 392.674 177.923 392.674C222.721 392.674 259.577 365.796 302.127 358.581C323.228 355.003 344.417 359.237 365.296 353.876C389.566 347.644 412.39 332.768 425.835 311.235C434.999 296.56 439.459 280.39 440.711 263.756Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M433.523 254.432C433.523 254.432 433.523 249.458 426.56 242.496C419.597 235.533 415.121 231.554 415.121 231.554C415.121 231.554 411.639 242.993 418.105 249.956C424.571 256.919 433.523 263.385 433.523 263.385V254.432Z",
    fill: "#3AF2AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423.417 285.492C423.417 285.492 423.417 280.519 416.454 273.556C409.491 266.593 405.015 262.614 405.015 262.614C405.015 262.614 401.533 274.053 407.999 281.016C414.465 287.979 423.417 294.445 423.417 294.445V285.492Z",
    fill: "#3AF2AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M433.085 262.903C433.085 262.903 433.61 257.957 441.27 251.769C448.93 245.581 453.801 242.097 453.801 242.097C453.801 242.097 456.054 253.84 448.889 260.081C441.724 266.322 432.138 271.805 432.138 271.805L433.085 262.903Z",
    fill: "#3AF2AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M420.877 299.585C420.877 299.585 421.919 294.722 430.187 289.372C438.454 284.022 443.665 281.07 443.665 281.07C443.665 281.07 444.672 292.985 436.891 298.438C429.11 303.892 419.002 308.338 419.002 308.338L420.877 299.585Z",
    fill: "#3AF2AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M423.172 339.58C423.172 339.58 423.172 334.606 430.135 327.643C437.098 320.68 441.574 316.701 441.574 316.701C441.574 316.701 445.056 328.14 438.59 335.103C432.124 342.066 423.172 348.532 423.172 348.532V339.58Z",
    fill: "#3AF2AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M423.056 349.342C423.056 349.342 423.763 344.419 417.86 336.537C411.957 328.655 408.092 324.081 408.092 324.081C408.092 324.081 403.02 334.909 408.431 342.72C413.841 350.531 421.784 358.203 421.784 358.203L423.056 349.342Z",
    fill: "#3AF2AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M416.19 378.273C416.19 378.273 416.19 373.3 423.153 366.337C430.116 359.374 434.592 355.395 434.592 355.395C434.592 355.395 438.074 366.834 431.608 373.797C425.142 380.76 416.19 387.226 416.19 387.226V378.273Z",
    fill: "#3AF2AE"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M420.84 404.504C420.84 404.504 419.58 399.693 424.553 391.193C429.525 382.694 432.848 377.711 432.848 377.711C432.848 377.711 439.113 387.895 434.622 396.269C430.131 404.643 423.108 413.165 423.108 413.165L420.84 404.504Z",
    fill: "#3AF2AE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M434.154 253.157C433.746 258.473 433.142 263.973 432.247 268.6C429.495 282.821 422.613 291.996 419.861 304.84C417.108 317.685 425.01 334.233 422.894 350.731C420.778 367.229 414.356 376.404 416.191 387.413C418.026 398.423 427.66 428.241 427.66 428.241",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M433.016 266.208L440.52 260.449",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M433.365 259.577L430.224 253.993",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M420.277 304.25C420.277 304.25 426.559 299.538 433.016 294.827",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M423.417 294.445C423.417 294.445 418.183 284.182 412.25 277.377",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M423.419 346.655C423.419 346.655 428.305 337.057 436.856 328.681",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M422.197 353.635C422.197 353.635 419.056 346.131 415.391 340.722C411.726 335.312 411.203 334.614 411.203 334.614",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M416.19 387.413C416.19 387.413 418.706 381.032 421.848 375.972C424.989 370.911 429.177 366.374 429.177 366.374",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M423.107 413.164C423.107 413.164 422.371 407.208 424.989 402.148C427.607 397.087 430.573 390.456 431.795 387.839",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M376.701 320.875C376.701 320.875 376.161 317.756 379.771 312.634C383.382 307.512 385.756 304.531 385.756 304.531C385.756 304.531 389.181 311.326 385.882 316.394C382.583 321.462 377.671 326.489 377.671 326.489L376.701 320.875Z",
    fill: "#3AF2AE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M386.409 339.256C386.409 339.256 385.869 336.137 389.48 331.015C393.09 325.893 395.465 322.912 395.465 322.912C395.465 322.912 398.89 329.707 395.591 334.775C392.292 339.843 387.38 344.87 387.38 344.87L386.409 339.256Z",
    fill: "#3AF2AE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M377.895 326.14C377.895 326.14 377.029 323.096 371.554 320.047C366.079 316.998 362.646 315.342 362.646 315.342C362.646 315.342 362.508 322.95 367.678 326.086C372.849 329.222 379.455 331.62 379.455 331.62L377.895 326.14Z",
    fill: "#3AF2AE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M389.532 347.817C389.532 347.817 388.35 344.881 382.585 342.424C376.82 339.967 373.232 338.681 373.232 338.681C373.232 338.681 373.894 346.262 379.365 348.837C384.836 351.412 391.658 353.103 391.658 353.103L389.532 347.817Z",
    fill: "#3AF2AE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M392.435 373.146C392.435 373.146 391.895 370.027 386.773 366.417C381.651 362.806 378.412 360.797 378.412 360.797C378.412 360.797 377.471 368.348 382.281 372.013C387.091 375.677 393.407 378.76 393.407 378.76L392.435 373.146Z",
    fill: "#3AF2AE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M393.567 379.255C393.567 379.255 392.589 376.245 395.435 370.661C398.281 365.078 400.208 361.789 400.208 361.789C400.208 361.789 404.564 368.029 402.019 373.514C399.474 379 395.326 384.673 395.326 384.673L393.567 379.255Z",
    fill: "#3AF2AE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M402.307 404.413C402.307 404.413 402.668 401.268 407.576 397.372C412.484 393.475 415.603 391.284 415.603 391.284C415.603 391.284 416.974 398.769 412.38 402.702C407.787 406.635 401.657 410.073 401.657 410.073L402.307 404.413Z",
    fill: "#3AF2AE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M401.014 396.652C401.014 396.652 400.474 393.533 395.352 389.923C390.23 386.313 386.991 384.303 386.991 384.303C386.991 384.303 386.05 391.854 390.86 395.519C395.67 399.183 401.986 402.266 401.986 402.266L401.014 396.652Z",
    fill: "#3AF2AE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M400.946 413.605C400.946 413.605 401.214 410.451 397.173 405.661C393.132 400.871 390.508 398.107 390.508 398.107C390.508 398.107 387.685 405.174 391.41 409.937C395.135 414.7 400.465 419.282 400.465 419.282L400.946 413.605Z",
    fill: "#3AF2AE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M376.167 320.144C377 323.433 377.976 326.817 379.039 329.621C382.309 338.24 387.62 343.246 390.74 351.002C393.86 358.758 390.702 369.993 393.82 380.108C396.938 390.224 401.961 395.28 402.006 402.383C402.051 409.486 399.247 429.23 399.247 429.23",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M378.297 328.205L372.966 325.408",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M377.358 324.085L378.721 320.242",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M390.415 350.678C390.415 350.678 385.964 348.405 381.404 346.152",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M387.381 344.87C387.381 344.87 389.549 337.866 392.531 332.954",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M393.048 377.61C393.048 377.61 388.942 372.122 382.671 367.797",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M394.572 381.854C394.572 381.854 395.727 376.808 397.438 373.017C399.149 369.227 399.401 368.732 399.401 368.732",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M401.764 407.772C401.764 407.772 405.297 403.441 407.496 401.82C409.695 400.2 411.219 398.583 411.219 398.583",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M402.006 402.384C402.006 402.384 399.735 398.656 397.216 395.824C394.697 392.992 391.578 390.601 391.578 390.601",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M400.464 419.283C400.464 419.283 400.279 415.468 398.088 412.579C395.897 409.69 393.317 405.853 392.267 404.345",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M92.673 277.32L88.293 264.805L92.673 270.124L89.232 251.352L94.55 264.805L96.428 238.524L99.557 263.554L102.998 258.548V264.805L107.066 256.358L104.875 271.063L108.63 268.56L102.685 276.695L92.673 277.32Z",
    fill: "#32DCDC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.44 274.192H90.17L93.099 307.044H103.511L106.44 274.192Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M136.952 306.665H81.527V424.062H136.952V306.665Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M139.99 306.665H109.24V424.062H139.99V306.665Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M136.525 306.665H109.24V424.062H136.525V306.665Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 396.775H109.24V420.817H133.461V396.775Z",
    fill: "#32DCDC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 398.074H109.24V401.156H133.461V398.074Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 415.771H109.24V418.853H133.461V415.771Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M113.834 397.27V427.67",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M122.28 397.27V427.67",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M129.697 397.27V427.67",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 311.029H109.24V346.379H133.461V311.029Z",
    fill: "#32DCDC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 312.506H109.24V316.008H133.461V312.506Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 335.167H109.24V338.669H133.461V335.167Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M113.834 311.591V346.135",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M122.28 311.591V346.135",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M129.697 311.591V346.135",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 353.634H109.24V388.984H133.461V353.634Z",
    fill: "#32DCDC",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 355.111H109.24V358.613H133.461V355.111Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M133.461 377.772H109.24V381.274H133.461V377.772Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M113.834 354.196V388.74",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M122.28 354.196V388.74",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M129.697 354.196V388.74",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M136.953 345.891H109.24V349.91H136.953V345.891Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M136.953 388.763H109.24V392.782H136.953V388.763Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M136.953 306.665V424.062",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M105.334 306.665V424.062H109.24V311.029H136.473V306.622L105.334 306.665Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M109.24 311.029V306.665",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M136.743 252.736C133.828 247.133 132.606 243.106 132.606 242.178C132.606 240.344 136.642 239.243 136.642 239.243C142.879 235.941 172.231 240.711 185.439 242.912C198.647 245.113 207.82 245.113 207.82 245.113C207.82 245.113 209.655 243.645 211.856 241.811C214.057 239.977 224.331 227.869 228.366 226.768C232.402 225.667 236.071 228.236 236.071 228.236C236.071 228.236 242.675 232.272 241.574 233.006C240.473 233.74 224.33 247.682 220.294 250.25C216.258 252.818 207.819 251.718 200.482 253.185C194.165 254.448 168.562 256.009 162.692 256.487C162.692 256.487 156.822 258.321 149.484 255.386",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 226,
    width: 110,
    height: 32
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M136.743 252.736C133.828 247.133 132.606 243.106 132.606 242.178C132.606 240.344 136.642 239.243 136.642 239.243C142.879 235.941 172.231 240.711 185.439 242.912C198.647 245.113 207.82 245.113 207.82 245.113C207.82 245.113 209.655 243.645 211.856 241.811C214.057 239.977 224.331 227.869 228.366 226.768C232.402 225.667 236.071 228.236 236.071 228.236C236.071 228.236 242.675 232.272 241.574 233.006C240.473 233.74 224.33 247.682 220.294 250.25C216.258 252.818 207.819 251.718 200.482 253.185C194.165 254.448 168.562 256.009 162.692 256.487C162.692 256.487 156.822 258.321 149.484 255.386",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.071 228.237C236.071 228.237 232.402 225.669 228.366 226.769C224.33 227.87 214.057 239.977 211.856 241.812C209.655 243.646 207.82 245.114 207.82 245.114C207.82 245.114 198.648 245.114 185.439 242.913C172.231 240.712 142.879 235.942 136.642 239.244C136.642 239.244 132.606 240.345 132.606 242.179C132.606 242.599 132.86 243.66 133.405 245.21C133.752 245.335 133.953 245.407 133.953 245.407C133.953 245.407 141.283 244.635 157.1 245.021C172.917 245.407 209.514 247.567 211.855 248.416C212.912 248.799 219.948 247.195 227.805 244.437C233.778 239.548 240.857 233.484 241.573 233.006C242.675 232.273 236.071 228.237 236.071 228.237Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 226,
    width: 110,
    height: 32
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M136.743 252.736C133.828 247.133 132.606 243.106 132.606 242.178C132.606 240.344 136.642 239.243 136.642 239.243C142.879 235.941 172.231 240.711 185.439 242.912C198.647 245.113 207.82 245.113 207.82 245.113C207.82 245.113 209.655 243.645 211.856 241.811C214.057 239.977 224.331 227.869 228.366 226.768C232.402 225.667 236.071 228.236 236.071 228.236C236.071 228.236 242.675 232.272 241.574 233.006C240.473 233.74 224.33 247.682 220.294 250.25C216.258 252.818 207.819 251.718 200.482 253.185C194.165 254.448 168.562 256.009 162.692 256.487C162.692 256.487 156.822 258.321 149.484 255.386",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M236.071 228.237C236.071 228.237 232.402 225.669 228.366 226.769C224.33 227.87 214.057 239.977 211.856 241.812C209.655 243.646 207.82 245.114 207.82 245.114C207.82 245.114 198.648 245.114 185.439 242.913C172.231 240.712 142.879 235.942 136.642 239.244C136.642 239.244 132.606 240.345 132.606 242.179C132.606 242.599 132.86 243.66 133.405 245.21C133.752 245.335 133.953 245.407 133.953 245.407C133.953 245.407 141.283 244.635 157.1 245.021C172.917 245.407 209.514 247.567 211.855 248.416C212.912 248.799 219.948 247.195 227.805 244.437C233.778 239.548 240.857 233.484 241.573 233.006C242.675 232.273 236.071 228.237 236.071 228.237Z",
    fill: "white"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M136.743 252.736C133.828 247.133 132.606 243.106 132.606 242.178C132.606 240.344 136.642 239.243 136.642 239.243C142.879 235.941 172.231 240.711 185.439 242.912C198.647 245.113 207.82 245.113 207.82 245.113C207.82 245.113 209.655 243.645 211.856 241.811C214.057 239.977 224.331 227.869 228.366 226.768C232.402 225.667 236.071 228.236 236.071 228.236C236.071 228.236 242.675 232.272 241.574 233.006C240.473 233.74 224.33 247.682 220.294 250.25C216.258 252.818 207.819 251.718 200.482 253.185C194.165 254.448 168.562 256.009 162.692 256.487C162.692 256.487 156.822 258.321 149.484 255.386",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M281.651 285.355C282.997 282.786 285.668 281.187 288.569 281.187H355.272C355.272 281.187 360.094 281.187 358.647 290.348C357.201 299.509 337.432 355.439 332.61 372.315C327.788 389.19 326.824 424.87 326.824 424.87H246.786C246.787 424.871 253.199 339.673 281.651 285.355Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 246,
    y: 281,
    width: 113,
    height: 144
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M281.651 285.355C282.997 282.786 285.668 281.187 288.569 281.187H355.272C355.272 281.187 360.094 281.187 358.647 290.348C357.201 299.509 337.432 355.439 332.61 372.315C327.788 389.19 326.824 424.87 326.824 424.87H246.786C246.787 424.871 253.199 339.673 281.651 285.355Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M311.694 281.188H288.569C285.668 281.188 282.997 282.786 281.651 285.356C253.2 339.673 246.787 424.871 246.787 424.871H282.674L291.519 391.262L328.422 398.871C328.683 396.052 328.984 393.182 329.329 390.355L328.525 381.315C328.525 381.315 320.965 373.357 318.577 371.367C316.19 369.377 317.781 365.796 317.383 350.277C316.985 334.758 303.058 323.616 297.885 314.066C292.712 304.516 300.671 298.547 307.833 288.997C310.385 285.593 311.417 283.053 311.694 281.188Z",
    fill: "black"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M281.651 285.355C282.997 282.786 285.668 281.187 288.569 281.187H355.272C355.272 281.187 360.094 281.187 358.647 290.348C357.201 299.509 337.432 355.439 332.61 372.315C327.788 389.19 326.824 424.87 326.824 424.87H246.786C246.787 424.871 253.199 339.673 281.651 285.355Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M343.7 297.099C336.956 312.834 322.67 375.096 320.378 424.871H326.824C326.824 424.871 327.788 389.191 332.61 372.316C337.432 355.44 357.2 299.51 358.647 290.349C360.093 281.188 355.272 281.188 355.272 281.188C355.272 281.188 349.106 284.486 343.7 297.099Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M226.532 265.66C226.532 265.66 215.892 259.423 211.856 248.416C207.82 237.409 243.409 219.798 258.819 218.697C274.229 217.596 278.632 221.632 287.804 237.409C296.976 253.186 303.214 274.833 298.444 285.473C293.674 296.113 285.603 298.681 291.473 307.487C297.343 316.293 313.854 341.242 312.753 352.982C311.652 364.723 300.279 374.996 283.768 376.097C267.258 377.198 245.244 367.291 226.899 351.148C208.554 335.005 213.324 311.156 219.928 303.451C226.532 295.746 236.438 292.811 237.172 285.106C237.905 277.401 226.532 265.66 226.532 265.66Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M271.876 248.249C277.531 258.769 284.599 272.86 286.805 281.371C290.668 296.269 270.803 305.65 276.321 312.823",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M264.182 234.468C264.182 234.468 266.379 238.216 269.425 243.744",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M293.82 260.938C294.467 262.946 294.908 264.982 295.083 267.024",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M268.044 228.95C268.044 228.95 285.418 241.792 292.355 257.163",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M243.876 238.626C231.465 242.114 213.622 247.759 215.073 251.022",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M255.353 235.571C255.353 235.571 252.697 236.226 248.749 237.287",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M239.991 229.095C244.548 227.592 252.055 225.871 261.975 226.191",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M234.937 231.157C234.937 231.157 236.137 230.49 238.421 229.643",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M132.606 242.179C132.606 242.237 132.611 242.307 132.62 242.388C132.611 242.307 132.606 242.237 132.606 242.179ZM136.743 252.736C134.377 248.187 133.126 244.677 132.739 243.022C133.125 244.676 134.376 248.186 136.743 252.736ZM132.629 242.446C132.638 242.514 132.648 242.584 132.664 242.667C132.648 242.585 132.639 242.515 132.629 242.446ZM132.677 242.729C132.694 242.819 132.714 242.912 132.738 243.017C132.713 242.912 132.694 242.819 132.677 242.729ZM136.743 252.736C139.591 258.212 144.055 265.192 150.583 272.264C163.791 286.573 201.949 323.997 205.618 326.565C209.287 329.133 208.186 336.471 205.618 343.809C203.05 351.147 193.51 361.787 193.877 373.528C194.244 385.269 197.913 403.247 197.546 406.916C197.179 410.585 188.007 423.059 188.007 423.059H282.667C282.667 423.059 270.875 408.071 270.875 402.935C270.875 397.798 287.07 332.069 287.804 327.299C288.538 322.529 285.603 319.227 279.732 318.86C273.862 318.493 251.481 313.723 250.38 310.054C249.279 306.385 256.25 292.443 256.25 292.443L234.236 293.544C234.236 293.544 233.135 303.083 231.668 304.918C230.2 306.753 227.999 303.083 222.863 300.515C217.726 297.947 207.82 295.745 204.151 292.81C200.482 289.875 165.26 256.854 165.26 256.854",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 242,
    width: 156,
    height: 182
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M132.606 242.179C132.606 242.237 132.611 242.307 132.62 242.388C132.611 242.307 132.606 242.237 132.606 242.179ZM136.743 252.736C134.377 248.187 133.126 244.677 132.739 243.022C133.125 244.676 134.376 248.186 136.743 252.736ZM132.629 242.446C132.638 242.514 132.648 242.584 132.664 242.667C132.648 242.585 132.639 242.515 132.629 242.446ZM132.677 242.729C132.694 242.819 132.714 242.912 132.738 243.017C132.713 242.912 132.694 242.819 132.677 242.729ZM136.743 252.736C139.591 258.212 144.055 265.192 150.583 272.264C163.791 286.573 201.949 323.997 205.618 326.565C209.287 329.133 208.186 336.471 205.618 343.809C203.05 351.147 193.51 361.787 193.877 373.528C194.244 385.269 197.913 403.247 197.546 406.916C197.179 410.585 188.007 423.059 188.007 423.059H282.667C282.667 423.059 270.875 408.071 270.875 402.935C270.875 397.798 287.07 332.069 287.804 327.299C288.538 322.529 285.603 319.227 279.732 318.86C273.862 318.493 251.481 313.723 250.38 310.054C249.279 306.385 256.25 292.443 256.25 292.443L234.236 293.544C234.236 293.544 233.135 303.083 231.668 304.918C230.2 306.753 227.999 303.083 222.863 300.515C217.726 297.947 207.82 295.745 204.151 292.81C200.482 289.875 165.26 256.854 165.26 256.854",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.767 295.645C211.602 298.844 213.426 301.732 213.426 301.732C213.426 301.732 219.599 305.204 221.142 305.204C222.685 305.204 231.944 310.219 231.944 310.219C231.944 310.219 239.66 308.29 236.959 301.732C236.484 300.578 235.33 298.976 233.741 297.11C233.282 300.022 232.54 303.829 231.668 304.919C230.2 306.754 227.999 303.084 222.863 300.516C219.507 298.838 214.125 297.316 209.767 295.645Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.932 280.791C179.598 270.296 165.26 256.855 165.26 256.855L156.921 255.651L155.944 256.209C155.944 256.209 179.477 277.042 184.492 279.356C187.6 280.791 189.226 280.596 190.932 280.791Z",
    fill: "#40B0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.803 291.652C202.532 291.413 202.232 291.145 201.903 290.85C202.359 291.606 202.623 292.087 202.623 292.087C202.623 292.087 202.688 291.916 202.803 291.652Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 242,
    width: 156,
    height: 182
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M132.606 242.179C132.606 242.237 132.611 242.307 132.62 242.388C132.611 242.307 132.606 242.237 132.606 242.179ZM136.743 252.736C134.377 248.187 133.126 244.677 132.739 243.022C133.125 244.676 134.376 248.186 136.743 252.736ZM132.629 242.446C132.638 242.514 132.648 242.584 132.664 242.667C132.648 242.585 132.639 242.515 132.629 242.446ZM132.677 242.729C132.694 242.819 132.714 242.912 132.738 243.017C132.713 242.912 132.694 242.819 132.677 242.729ZM136.743 252.736C139.591 258.212 144.055 265.192 150.583 272.264C163.791 286.573 201.949 323.997 205.618 326.565C209.287 329.133 208.186 336.471 205.618 343.809C203.05 351.147 193.51 361.787 193.877 373.528C194.244 385.269 197.913 403.247 197.546 406.916C197.179 410.585 188.007 423.059 188.007 423.059H282.667C282.667 423.059 270.875 408.071 270.875 402.935C270.875 397.798 287.07 332.069 287.804 327.299C288.538 322.529 285.603 319.227 279.732 318.86C273.862 318.493 251.481 313.723 250.38 310.054C249.279 306.385 256.25 292.443 256.25 292.443L234.236 293.544C234.236 293.544 233.135 303.083 231.668 304.918C230.2 306.753 227.999 303.083 222.863 300.515C217.726 297.947 207.82 295.745 204.151 292.81C200.482 289.875 165.26 256.854 165.26 256.854",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_914_22995)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.767 295.645C211.602 298.844 213.426 301.732 213.426 301.732C213.426 301.732 219.599 305.204 221.142 305.204C222.685 305.204 231.944 310.219 231.944 310.219C231.944 310.219 239.66 308.29 236.959 301.732C236.484 300.578 235.33 298.976 233.741 297.11C233.282 300.022 232.54 303.829 231.668 304.919C230.2 306.754 227.999 303.084 222.863 300.516C219.507 298.838 214.125 297.316 209.767 295.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.932 280.791C179.598 270.296 165.26 256.855 165.26 256.855L156.921 255.651L155.944 256.209C155.944 256.209 179.477 277.042 184.492 279.356C187.6 280.791 189.226 280.596 190.932 280.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.803 291.652C202.532 291.413 202.232 291.145 201.903 290.85C202.359 291.606 202.623 292.087 202.623 292.087C202.623 292.087 202.688 291.916 202.803 291.652Z",
    fill: "white"
  })))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M136.743 252.736C139.591 258.212 144.055 265.192 150.583 272.264C163.791 286.573 201.949 323.997 205.618 326.565C209.287 329.133 208.186 336.471 205.618 343.809C203.05 351.147 193.51 361.787 193.877 373.528C194.244 385.269 197.913 403.247 197.546 406.916C197.179 410.585 188.007 423.059 188.007 423.059H282.667C282.667 423.059 270.875 408.071 270.875 402.935C270.875 397.798 287.07 332.069 287.804 327.299C288.538 322.529 285.603 319.227 279.732 318.86C273.862 318.493 251.481 313.723 250.38 310.054C249.279 306.385 256.25 292.443 256.25 292.443L234.236 293.544C234.236 293.544 233.135 303.083 231.668 304.918C230.2 306.753 227.999 303.083 222.863 300.515C217.726 297.947 207.82 295.745 204.151 292.81C200.482 289.875 165.26 256.854 165.26 256.854M132.606 242.179C132.606 242.237 132.611 242.307 132.62 242.388C132.611 242.307 132.606 242.237 132.606 242.179ZM136.743 252.736C134.377 248.187 133.126 244.677 132.739 243.022C133.125 244.676 134.376 248.186 136.743 252.736ZM132.629 242.446C132.638 242.514 132.648 242.584 132.664 242.667C132.648 242.585 132.639 242.515 132.629 242.446ZM132.677 242.729C132.694 242.819 132.714 242.912 132.738 243.017C132.713 242.912 132.694 242.819 132.677 242.729Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M165.26 256.855C165.26 256.855 153.545 257.074 146.998 251.683",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 310.055C249.279 306.386 256.25 292.444 256.25 292.444L234.236 293.545C234.236 293.545 233.135 303.084 231.668 304.919C230.2 306.754 227.999 303.084 222.863 300.516C222.472 300.32 222.045 300.127 221.603 299.936L220.268 320.854C220.268 320.854 222.197 341.105 245.34 337.247C254.709 335.685 264.71 327.328 273.296 317.933C264.465 316.298 251.22 312.857 250.38 310.055Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 292,
    width: 54,
    height: 46
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 310.055C249.279 306.386 256.25 292.444 256.25 292.444L234.236 293.545C234.236 293.545 233.135 303.084 231.668 304.919C230.2 306.754 227.999 303.084 222.863 300.516C222.472 300.32 222.045 300.127 221.603 299.936L220.268 320.854C220.268 320.854 222.197 341.105 245.34 337.247C254.709 335.685 264.71 327.328 273.296 317.933C264.465 316.298 251.22 312.857 250.38 310.055Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.758 295.208C249.758 295.208 248.426 302.666 247.361 310.923C246.296 319.18 245.497 325.306 245.497 325.306L250.38 310.055L255.884 293.877C255.884 293.877 250.557 293.877 249.758 295.208Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 292,
    width: 54,
    height: 46
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 310.055C249.279 306.386 256.25 292.444 256.25 292.444L234.236 293.545C234.236 293.545 233.135 303.084 231.668 304.919C230.2 306.754 227.999 303.084 222.863 300.516C222.472 300.32 222.045 300.127 221.603 299.936L220.268 320.854C220.268 320.854 222.197 341.105 245.34 337.247C254.709 335.685 264.71 327.328 273.296 317.933C264.465 316.298 251.22 312.857 250.38 310.055Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M249.758 295.208C249.758 295.208 248.426 302.666 247.361 310.923C246.296 319.18 245.497 325.306 245.497 325.306L250.38 310.055L255.884 293.877C255.884 293.877 250.557 293.877 249.758 295.208Z",
    fill: "white"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 310.055C249.279 306.386 256.25 292.444 256.25 292.444L234.236 293.545C234.236 293.545 233.135 303.084 231.668 304.919C230.2 306.754 227.999 303.084 222.863 300.516C222.472 300.32 222.045 300.127 221.603 299.936L220.268 320.854C220.268 320.854 222.197 341.105 245.34 337.247C254.709 335.685 264.71 327.328 273.296 317.933C264.465 316.298 251.22 312.857 250.38 310.055Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M231.668 304.918C230.2 306.753 227.999 303.083 222.863 300.515C219.616 298.891 214.465 297.414 210.186 295.805C208.975 292.939 207.378 289.195 206.352 286.939C204.517 282.903 201.582 285.472 201.582 285.472C201.582 285.472 199.747 283.637 197.913 279.602C196.079 275.566 193.143 275.933 189.107 275.199C185.071 274.465 176.633 266.76 176.633 266.76C176.633 266.76 172.684 263.802 171.046 262.271C169.151 266.014 164.596 272.593 154.761 276.698C170.445 293.09 202.281 324.23 205.617 326.565C209.286 329.133 208.185 336.471 205.617 343.809C203.049 351.147 193.509 361.787 193.876 373.528C194.243 385.269 197.912 403.247 197.545 406.916C197.218 410.186 189.9 420.445 188.313 422.637L192.042 423.059H211.455C211.35 413.222 211.355 373.058 218.092 357.017C225.798 338.673 231.668 304.918 231.668 304.918Z",
    fill: "#40B0D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 262,
    width: 78,
    height: 162
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M231.668 304.918C230.2 306.753 227.999 303.083 222.863 300.515C219.616 298.891 214.465 297.414 210.186 295.805C208.975 292.939 207.378 289.195 206.352 286.939C204.517 282.903 201.582 285.472 201.582 285.472C201.582 285.472 199.747 283.637 197.913 279.602C196.079 275.566 193.143 275.933 189.107 275.199C185.071 274.465 176.633 266.76 176.633 266.76C176.633 266.76 172.684 263.802 171.046 262.271C169.151 266.014 164.596 272.593 154.761 276.698C170.445 293.09 202.281 324.23 205.617 326.565C209.286 329.133 208.185 336.471 205.617 343.809C203.049 351.147 193.509 361.787 193.876 373.528C194.243 385.269 197.912 403.247 197.545 406.916C197.218 410.186 189.9 420.445 188.313 422.637L192.042 423.059H211.455C211.35 413.222 211.355 373.058 218.092 357.017C225.798 338.673 231.668 304.918 231.668 304.918Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M222.863 300.516C219.616 298.892 214.465 297.415 210.186 295.806C208.975 292.94 207.378 289.196 206.352 286.94C204.517 282.904 201.582 285.473 201.582 285.473C201.582 285.473 199.747 283.638 197.913 279.603C196.079 275.567 193.143 275.934 189.107 275.2C185.071 274.466 176.633 266.761 176.633 266.761C176.633 266.761 172.684 263.803 171.046 262.272C170.414 263.519 169.478 265.084 168.159 266.765C174.717 272.307 181.96 278.188 184.491 279.356C189.506 281.671 190.664 279.742 194.522 282.057C198.38 284.372 202.623 292.087 202.623 292.087C202.623 292.087 204.938 285.914 206.867 290.158C208.796 294.402 213.425 301.732 213.425 301.732C213.425 301.732 219.598 305.204 221.141 305.204C222.35 305.204 228.281 308.275 230.798 309.608C231.36 306.684 231.668 304.918 231.668 304.918C230.201 306.753 227.999 303.084 222.863 300.516Z",
    fill: "black"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M231.668 304.918C230.2 306.753 227.999 303.083 222.863 300.515C219.616 298.891 214.465 297.414 210.186 295.805C208.975 292.939 207.378 289.195 206.352 286.939C204.517 282.903 201.582 285.472 201.582 285.472C201.582 285.472 199.747 283.637 197.913 279.602C196.079 275.566 193.143 275.933 189.107 275.199C185.071 274.465 176.633 266.76 176.633 266.76C176.633 266.76 172.684 263.802 171.046 262.271C169.151 266.014 164.596 272.593 154.761 276.698C170.445 293.09 202.281 324.23 205.617 326.565C209.286 329.133 208.185 336.471 205.617 343.809C203.049 351.147 193.509 361.787 193.876 373.528C194.243 385.269 197.912 403.247 197.545 406.916C197.218 410.186 189.9 420.445 188.313 422.637L192.042 423.059H211.455C211.35 413.222 211.355 373.058 218.092 357.017C225.798 338.673 231.668 304.918 231.668 304.918Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M231.93 303.644C231.93 303.644 227.369 302.241 224.562 304.696C221.755 307.152 217.545 319.783 215.089 333.466C212.633 347.149 218.093 357.017 218.093 357.017C218.093 357.017 223.861 341.886 225.615 334.518C227.369 327.151 231.93 303.644 231.93 303.644Z",
    fill: "#40B0D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 303,
    width: 18,
    height: 55
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M231.93 303.644C231.93 303.644 227.369 302.241 224.562 304.696C221.755 307.152 217.545 319.783 215.089 333.466C212.633 347.149 218.093 357.017 218.093 357.017C218.093 357.017 223.861 341.886 225.615 334.518C227.369 327.151 231.93 303.644 231.93 303.644Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M223.18 305.868C223.18 305.868 226.475 305.073 227.838 305.527C229.201 305.981 231.019 307.459 231.019 307.459L231.929 303.644C231.929 303.644 229.769 302.46 227.497 302.914C225.225 303.369 223.18 305.868 223.18 305.868Z",
    fill: "black"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M231.93 303.644C231.93 303.644 227.369 302.241 224.562 304.696C221.755 307.152 217.545 319.783 215.089 333.466C212.633 347.149 218.093 357.017 218.093 357.017C218.093 357.017 223.861 341.886 225.615 334.518C227.369 327.151 231.93 303.644 231.93 303.644Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M201.216 304.838L207.086 328.686L193.878 298.601",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M239.893 423.059H282.667C282.667 423.059 270.875 408.071 270.875 402.935C270.875 397.798 287.07 332.069 287.804 327.299C288.538 322.529 285.603 319.227 279.732 318.86C273.862 318.493 251.481 313.723 250.38 310.054C250.38 310.054 241.941 339.773 239.006 359.952C236.489 377.257 239.098 413.175 239.893 423.059Z",
    fill: "#40B0D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 310,
    width: 51,
    height: 114
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M239.893 423.059H282.667C282.667 423.059 270.875 408.071 270.875 402.935C270.875 397.798 287.07 332.069 287.804 327.299C288.538 322.529 285.603 319.227 279.732 318.86C273.862 318.493 251.481 313.723 250.38 310.054C250.38 310.054 241.941 339.773 239.006 359.952C236.489 377.257 239.098 413.175 239.893 423.059Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M279.732 318.86C274.921 318.559 259.028 315.301 252.84 312.116L255.085 317.315C255.085 317.315 260.678 320.511 268.136 321.843C275.594 323.175 282.519 322.908 287.047 329.567C287.121 329.676 287.195 329.79 287.269 329.902C287.552 328.62 287.738 327.718 287.803 327.299C288.537 322.529 285.602 319.227 279.732 318.86Z",
    fill: "black"
  }))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M239.893 423.059H282.667C282.667 423.059 270.875 408.071 270.875 402.935C270.875 397.798 287.07 332.069 287.804 327.299C288.538 322.529 285.603 319.227 279.732 318.86C273.862 318.493 251.481 313.723 250.38 310.054C250.38 310.054 241.941 339.773 239.006 359.952C236.489 377.257 239.098 413.175 239.893 423.059Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 310.055C250.38 310.055 239.065 346.091 239.006 359.953C239.006 359.953 255.086 340.483 257.192 326.8C259.297 313.117 250.38 310.055 250.38 310.055Z",
    fill: "#40B0D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 239,
    y: 310,
    width: 19,
    height: 50
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 310.055C250.38 310.055 239.065 346.091 239.006 359.953C239.006 359.953 255.086 340.483 257.192 326.8C259.297 313.117 250.38 310.055 250.38 310.055Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M248.426 314.652C248.426 314.652 253.487 314.119 257.215 318.914C257.215 318.914 254.996 312.383 250.379 310.055L248.426 314.652Z",
    fill: "black"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M250.38 310.055C250.38 310.055 239.065 346.091 239.006 359.953C239.006 359.953 255.086 340.483 257.192 326.8C259.297 313.117 250.38 310.055 250.38 310.055Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M371.235 416.287C371.235 416.287 379.522 416.628 384.949 417.411C390.375 418.193 395.866 418.277 395.866 418.277C395.866 418.277 392.899 412.223 389.673 410.515C386.447 408.808 380.667 405.737 375.811 406.417C370.955 407.097 364.021 411.956 364.578 413.559C365.135 415.16 367.753 415.825 371.235 416.287Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 364,
    y: 406,
    width: 32,
    height: 13
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M371.235 416.287C371.235 416.287 379.522 416.628 384.949 417.411C390.375 418.193 395.866 418.277 395.866 418.277C395.866 418.277 392.899 412.223 389.673 410.515C386.447 408.808 380.667 405.737 375.811 406.417C370.955 407.097 364.021 411.956 364.578 413.559C365.135 415.16 367.753 415.825 371.235 416.287Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.235 416.287C371.235 416.287 379.522 416.628 384.949 417.411C390.375 418.193 395.866 418.277 395.866 418.277C395.866 418.277 392.899 412.223 389.673 410.515C386.447 408.808 380.667 405.737 375.811 406.417C370.955 407.097 364.021 411.956 364.578 413.559C365.135 415.16 367.753 415.825 371.235 416.287Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 364,
    y: 406,
    width: 32,
    height: 13
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M371.235 416.287C371.235 416.287 379.522 416.628 384.949 417.411C390.375 418.193 395.866 418.277 395.866 418.277C395.866 418.277 392.899 412.223 389.673 410.515C386.447 408.808 380.667 405.737 375.811 406.417C370.955 407.097 364.021 411.956 364.578 413.559C365.135 415.16 367.753 415.825 371.235 416.287Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M371.235 416.287C371.235 416.287 379.522 416.628 384.949 417.411C390.375 418.193 395.866 418.277 395.866 418.277C395.866 418.277 392.899 412.223 389.673 410.515C386.447 408.808 380.667 405.737 375.811 406.417C370.955 407.097 364.021 411.956 364.578 413.559C365.135 415.16 367.753 415.825 371.235 416.287Z",
    fill: "white"
  }))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M371.235 416.287C371.235 416.287 379.522 416.628 384.949 417.411C390.375 418.193 395.866 418.277 395.866 418.277C395.866 418.277 392.899 412.223 389.673 410.515C386.447 408.808 380.667 405.737 375.811 406.417C370.955 407.097 364.021 411.956 364.578 413.559C365.135 415.16 367.753 415.825 371.235 416.287Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M384.959 413.814C384.959 413.814 391.526 410.402 393.174 410.445C394.821 410.487 405.714 417.873 405.172 419.053C404.63 420.233 402.56 420.718 401.729 420.328C400.523 419.763 393.185 416.641 393.185 416.641L388.382 417.768L384.959 413.814Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 384,
    y: 410,
    width: 22,
    height: 11
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M384.959 413.814C384.959 413.814 391.526 410.402 393.174 410.445C394.821 410.487 405.714 417.873 405.172 419.053C404.63 420.233 402.56 420.718 401.729 420.328C400.523 419.763 393.185 416.641 393.185 416.641L388.382 417.768L384.959 413.814Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.959 413.814C384.959 413.814 391.526 410.402 393.174 410.445C394.821 410.487 405.714 417.873 405.172 419.053C404.63 420.233 402.048 421.189 401.729 420.328C401.41 419.467 393.185 416.641 393.185 416.641L388.382 417.768L384.959 413.814Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 384,
    y: 410,
    width: 22,
    height: 11
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M384.959 413.814C384.959 413.814 391.526 410.402 393.174 410.445C394.821 410.487 405.714 417.873 405.172 419.053C404.63 420.233 402.56 420.718 401.729 420.328C400.523 419.763 393.185 416.641 393.185 416.641L388.382 417.768L384.959 413.814Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M384.959 413.814C384.959 413.814 391.526 410.402 393.174 410.445C394.821 410.487 405.714 417.873 405.172 419.053C404.63 420.233 402.048 421.189 401.729 420.328C401.41 419.467 393.185 416.641 393.185 416.641L388.382 417.768L384.959 413.814Z",
    fill: "white"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M384.959 413.814C384.959 413.814 391.526 410.402 393.174 410.445C394.821 410.487 405.714 417.873 405.172 419.053C404.63 420.233 402.56 420.718 401.729 420.328C400.523 419.763 393.185 416.641 393.185 416.641L388.382 417.768L384.959 413.814Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M380.308 408.199C380.308 408.199 389.072 407.915 390.811 408.803C392.55 409.691 400.41 423.159 399.227 424.143C398.044 425.126 394.795 424.827 394.895 423.743C394.995 422.66 387.652 415.429 387.652 415.429L381.942 414.174L380.308 408.199Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 380,
    y: 408,
    width: 20,
    height: 17
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M380.308 408.199C380.308 408.199 389.072 407.915 390.811 408.803C392.55 409.691 400.41 423.159 399.227 424.143C398.044 425.126 394.795 424.827 394.895 423.743C394.995 422.66 387.652 415.429 387.652 415.429L381.942 414.174L380.308 408.199Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.308 408.199C380.308 408.199 389.072 407.915 390.811 408.803C392.55 409.691 400.41 423.159 399.227 424.143C398.044 425.126 394.795 424.827 394.895 423.743C394.995 422.66 387.652 415.429 387.652 415.429L381.942 414.174L380.308 408.199Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 380,
    y: 408,
    width: 20,
    height: 17
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M380.308 408.199C380.308 408.199 389.072 407.915 390.811 408.803C392.55 409.691 400.41 423.159 399.227 424.143C398.044 425.126 394.795 424.827 394.895 423.743C394.995 422.66 387.652 415.429 387.652 415.429L381.942 414.174L380.308 408.199Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M380.308 408.199C380.308 408.199 389.072 407.915 390.811 408.803C392.55 409.691 400.41 423.159 399.227 424.143C398.044 425.126 394.795 424.827 394.895 423.743C394.995 422.66 387.652 415.429 387.652 415.429L381.942 414.174L380.308 408.199Z",
    fill: "white"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M380.308 408.199C380.308 408.199 389.072 407.915 390.811 408.803C392.55 409.691 400.41 423.159 399.227 424.143C398.044 425.126 394.795 424.827 394.895 423.743C394.995 422.66 387.652 415.429 387.652 415.429L381.942 414.174L380.308 408.199Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M375.125 406.391C375.125 406.391 383.994 406.104 385.754 407.003C387.513 407.902 395.468 421.531 394.271 422.526C393.074 423.521 389.786 423.218 389.887 422.122C389.988 421.026 382.557 413.708 382.557 413.708L376.779 412.438L375.125 406.391Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 375,
    y: 406,
    width: 20,
    height: 18
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M375.125 406.391C375.125 406.391 383.994 406.104 385.754 407.003C387.513 407.902 395.468 421.531 394.271 422.526C393.074 423.521 389.786 423.218 389.887 422.122C389.988 421.026 382.557 413.708 382.557 413.708L376.779 412.438L375.125 406.391Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.125 406.391C375.125 406.391 383.994 406.104 385.754 407.003C387.513 407.902 395.468 421.531 394.271 422.526C393.074 423.521 389.786 423.218 389.887 422.122C389.988 421.026 382.557 413.708 382.557 413.708L376.779 412.438L375.125 406.391Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 375,
    y: 406,
    width: 20,
    height: 18
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M375.125 406.391C375.125 406.391 383.994 406.104 385.754 407.003C387.513 407.902 395.468 421.531 394.271 422.526C393.074 423.521 389.786 423.218 389.887 422.122C389.988 421.026 382.557 413.708 382.557 413.708L376.779 412.438L375.125 406.391Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M375.125 406.391C375.125 406.391 383.994 406.104 385.754 407.003C387.513 407.902 395.468 421.531 394.271 422.526C393.074 423.521 389.786 423.218 389.887 422.122C389.988 421.026 382.557 413.708 382.557 413.708L376.779 412.438L375.125 406.391Z",
    fill: "white"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M375.125 406.391C375.125 406.391 383.994 406.104 385.754 407.003C387.513 407.902 395.468 421.531 394.271 422.526C393.074 423.521 389.786 423.218 389.887 422.122C389.988 421.026 382.557 413.708 382.557 413.708L376.779 412.438L375.125 406.391Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M274.27 355.569C280.687 365.459 293.576 390.516 297.343 393.341C303.213 397.744 342.452 408.422 346.235 411.35C350.018 414.278 349.749 417.201 353.335 418.268C356.921 419.336 370.341 422.415 375.456 422.887C380.571 423.359 378.283 420.2 378.283 420.2L369.551 414.236L377.164 412.359C377.164 412.359 384.792 421.537 386.22 422.037C387.648 422.537 390.175 422.016 390.008 420.912C389.733 419.098 381.592 404.292 378.703 403.658C375.814 403.023 358.272 405.459 358.272 405.459C358.272 405.459 321.486 380.647 320.825 379.766C320.825 379.766 318.624 373.529 316.789 370.961C314.954 368.393 313.854 369.126 313.854 369.126C313.854 369.126 314.588 365.824 313.487 364.723C312.386 363.622 307.617 358.853 307.617 358.853L307.411 359.135C306.446 357.12 305.421 354.85 304.315 352.249C301.24 345.024 290.373 324.732 288.538 321.796C287.175 319.615 275.686 318.042 269.87 317.378",
    fill: "#40B0D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 317,
    width: 122,
    height: 106
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M274.27 355.569C280.687 365.459 293.576 390.516 297.343 393.341C303.213 397.744 342.452 408.422 346.235 411.35C350.018 414.278 349.749 417.201 353.335 418.268C356.921 419.336 370.341 422.415 375.456 422.887C380.571 423.359 378.283 420.2 378.283 420.2L369.551 414.236L377.164 412.359C377.164 412.359 384.792 421.537 386.22 422.037C387.648 422.537 390.175 422.016 390.008 420.912C389.733 419.098 381.592 404.292 378.703 403.658C375.814 403.023 358.272 405.459 358.272 405.459C358.272 405.459 321.486 380.647 320.825 379.766C320.825 379.766 318.624 373.529 316.789 370.961C314.954 368.393 313.854 369.126 313.854 369.126C313.854 369.126 314.588 365.824 313.487 364.723C312.386 363.622 307.617 358.853 307.617 358.853L307.411 359.135C306.446 357.12 305.421 354.85 304.315 352.249C301.24 345.024 290.373 324.732 288.538 321.796C287.175 319.615 275.686 318.042 269.87 317.378",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M299.832 356.202C304.626 360.464 303.028 360.464 301.963 364.193C300.898 367.922 302.762 362.861 307.29 363.128C311.818 363.394 310.486 369.254 309.953 370.319C309.42 371.384 315.546 372.716 314.481 375.113C313.416 377.51 307.29 380.973 303.827 384.435C300.364 387.897 312.883 378.842 317.144 378.575C318.439 378.494 319.511 378.658 320.408 378.635C319.684 376.719 318.138 372.849 316.788 370.959C314.953 368.391 313.853 369.124 313.853 369.124C313.853 369.124 314.587 365.822 313.486 364.721C312.385 363.62 307.616 358.851 307.616 358.851L307.41 359.133C306.445 357.118 305.42 354.848 304.314 352.247C301.239 345.022 290.372 324.73 288.537 321.794C287.174 319.613 275.685 318.04 269.869 317.376L270.403 322.007L270.533 322.109C270.533 322.109 277.724 323.441 280.122 323.707C282.519 323.973 285.449 326.104 285.183 327.702C284.917 329.3 277.992 336.491 280.122 337.024C282.253 337.557 284.65 331.697 287.047 332.496C289.444 333.296 295.037 351.941 299.832 356.202Z",
    fill: "black"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M274.27 355.569C280.687 365.459 293.576 390.516 297.343 393.341C303.213 397.744 342.452 408.422 346.235 411.35C350.018 414.278 349.749 417.201 353.335 418.268C356.921 419.336 370.341 422.415 375.456 422.887C380.571 423.359 378.283 420.2 378.283 420.2L369.551 414.236L377.164 412.359C377.164 412.359 384.792 421.537 386.22 422.037C387.648 422.537 390.175 422.016 390.008 420.912C389.733 419.098 381.592 404.292 378.703 403.658C375.814 403.023 358.272 405.459 358.272 405.459C358.272 405.459 321.486 380.647 320.825 379.766C320.825 379.766 318.624 373.529 316.789 370.961C314.954 368.393 313.854 369.126 313.854 369.126C313.854 369.126 314.588 365.824 313.487 364.723C312.386 363.622 307.617 358.853 307.617 358.853L307.411 359.135C306.446 357.12 305.421 354.85 304.315 352.249C301.24 345.024 290.373 324.732 288.538 321.796C287.175 319.615 275.686 318.042 269.87 317.378",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M274.371 341.978C274.097 342.875 273.866 343.784 273.689 344.701",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M284.086 325.447C284.086 325.447 279.399 330.56 276.205 337.3",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M298.776 382.232C301.479 378.281 305.755 373.16 310.521 371.71",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M295.785 387.147C295.785 387.147 296.266 386.21 297.127 384.792",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M295.785 380.831C295.785 380.831 300.697 368.551 305.609 365.393C310.521 362.235 307.714 368.551 307.714 368.551",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M346.235 411.349C350.018 414.277 349.749 417.2 353.335 418.267C356.921 419.335 370.341 422.414 375.456 422.886C380.571 423.358 378.283 420.199 378.283 420.199L369.551 414.235L377.164 412.358C377.164 412.358 384.792 421.536 386.22 422.036C387.648 422.536 390.367 422.718 390.008 420.911C389.311 417.404 381.592 404.291 378.703 403.657C375.814 403.022 358.272 405.458 358.272 405.458C358.272 405.458 324.759 382.432 321.092 379.968C306.859 381.337 300.071 388.794 297.246 393.261C297.278 393.286 297.313 393.317 297.344 393.34C303.213 397.743 342.452 408.421 346.235 411.349Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 297,
    y: 379,
    width: 94,
    height: 44
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M346.235 411.349C350.018 414.277 349.749 417.2 353.335 418.267C356.921 419.335 370.341 422.414 375.456 422.886C380.571 423.358 378.283 420.199 378.283 420.199L369.551 414.235L377.164 412.358C377.164 412.358 384.792 421.536 386.22 422.036C387.648 422.536 390.367 422.718 390.008 420.911C389.311 417.404 381.592 404.291 378.703 403.657C375.814 403.022 358.272 405.458 358.272 405.458C358.272 405.458 324.759 382.432 321.092 379.968C306.859 381.337 300.071 388.794 297.246 393.261C297.278 393.286 297.313 393.317 297.344 393.34C303.213 397.743 342.452 408.421 346.235 411.349Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.007 420.912C388.194 416.458 381.591 404.292 378.702 403.658C375.813 403.023 358.271 405.459 358.271 405.459C358.271 405.459 324.758 382.433 321.091 379.969C316.824 380.379 313.238 381.343 310.216 382.604C315.507 385.587 350.77 405.579 355.206 406.491C359.931 407.462 375.681 404.902 378.452 406.762C380.214 407.945 385.424 416.255 388.988 422.153C390.02 421.978 390.373 421.811 390.007 420.912Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 297,
    y: 379,
    width: 94,
    height: 44
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M346.235 411.349C350.018 414.277 349.749 417.2 353.335 418.267C356.921 419.335 370.341 422.414 375.456 422.886C380.571 423.358 378.283 420.199 378.283 420.199L369.551 414.235L377.164 412.358C377.164 412.358 384.792 421.536 386.22 422.036C387.648 422.536 390.367 422.718 390.008 420.911C389.311 417.404 381.592 404.291 378.703 403.657C375.814 403.022 358.272 405.458 358.272 405.458C358.272 405.458 324.759 382.432 321.092 379.968C306.859 381.337 300.071 388.794 297.246 393.261C297.278 393.286 297.313 393.317 297.344 393.34C303.213 397.743 342.452 408.421 346.235 411.349Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M390.007 420.912C387.171 414.541 381.591 404.292 378.702 403.658C375.813 403.023 358.271 405.459 358.271 405.459C358.271 405.459 324.758 382.433 321.091 379.969C316.824 380.379 313.238 381.343 310.216 382.604C315.507 385.587 350.77 405.579 355.206 406.491C359.931 407.462 375.681 404.902 378.452 406.762C380.214 407.945 385.424 416.255 388.988 422.153C390.02 421.978 390.401 421.799 390.007 420.912Z",
    fill: "white"
  }))), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M346.235 411.349C350.018 414.277 349.749 417.2 353.335 418.267C356.921 419.335 370.341 422.414 375.456 422.886C380.571 423.358 378.283 420.199 378.283 420.199L369.551 414.235L377.164 412.358C377.164 412.358 384.792 421.536 386.22 422.036C387.648 422.536 390.367 422.718 390.008 420.911C389.311 417.404 381.592 404.291 378.703 403.657C375.814 403.022 358.272 405.458 358.272 405.458C358.272 405.458 324.759 382.432 321.092 379.968C306.859 381.337 300.071 388.794 297.246 393.261C297.278 393.286 297.313 393.317 297.344 393.34C303.213 397.743 342.452 408.421 346.235 411.349Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M257.849 236.73L227.731 249.296C227.731 249.296 227.423 257.068 223.864 264.605C220.305 272.142 222.381 286.387 225.8 294.075C229.219 301.763 244.286 298.757 249.835 297.799C255.385 296.841 260.774 294.614 260.774 294.614C260.774 294.614 265.693 296.828 270.526 293.254C270.526 293.254 254.373 247.995 257.849 236.73Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 236,
    width: 49,
    height: 64
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M257.849 236.73L227.731 249.296C227.731 249.296 227.423 257.068 223.864 264.605C220.305 272.142 222.381 286.387 225.8 294.075C229.219 301.763 244.286 298.757 249.835 297.799C255.385 296.841 260.774 294.614 260.774 294.614C260.774 294.614 265.693 296.828 270.526 293.254C270.526 293.254 254.373 247.995 257.849 236.73Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.849 236.73L227.731 249.296C227.731 249.296 227.423 257.068 223.864 264.605C220.305 272.142 222.381 286.387 225.8 294.075C226.38 295.38 227.302 296.371 228.45 297.122V296.54C228.45 296.54 222.857 282.69 223.922 274.699C224.987 266.709 229.515 262.713 230.048 257.653C230.581 252.592 230.314 250.195 240.436 246.466C250.557 242.737 254.819 239.275 255.884 243.003C256.949 246.732 261.211 271.236 264.141 277.096C267.071 282.956 266.804 289.082 262.277 291.745C258.627 293.892 253.075 296.728 247.71 298.167C248.511 298.031 249.232 297.902 249.835 297.798C255.385 296.84 260.774 294.613 260.774 294.613C260.774 294.613 265.693 296.827 270.526 293.253C270.526 293.253 254.373 247.995 257.849 236.73Z",
    fill: "#40B0D5"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 236,
    width: 49,
    height: 64
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M257.849 236.73L227.731 249.296C227.731 249.296 227.423 257.068 223.864 264.605C220.305 272.142 222.381 286.387 225.8 294.075C229.219 301.763 244.286 298.757 249.835 297.799C255.385 296.841 260.774 294.614 260.774 294.614C260.774 294.614 265.693 296.828 270.526 293.254C270.526 293.254 254.373 247.995 257.849 236.73Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M257.849 236.73L227.731 249.296C227.731 249.296 227.423 257.068 223.864 264.605C220.305 272.142 222.381 286.387 225.8 294.075C226.38 295.38 227.302 296.371 228.45 297.122V296.54C228.45 296.54 222.857 282.69 223.922 274.699C224.987 266.709 229.515 262.713 230.048 257.653C230.581 252.592 230.314 250.195 240.436 246.466C250.557 242.737 254.819 239.275 255.884 243.003C256.949 246.732 261.211 271.236 264.141 277.096C267.071 282.956 266.804 289.082 262.277 291.745C258.627 293.892 253.075 296.728 247.71 298.167C248.511 298.031 249.232 297.902 249.835 297.798C255.385 296.84 260.774 294.613 260.774 294.613C260.774 294.613 265.693 296.827 270.526 293.253C270.526 293.253 254.373 247.995 257.849 236.73Z",
    fill: "white"
  }))), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M257.849 236.73L227.731 249.296C227.731 249.296 227.423 257.068 223.864 264.605C220.305 272.142 222.381 286.387 225.8 294.075C229.219 301.763 244.286 298.757 249.835 297.799C255.385 296.841 260.774 294.614 260.774 294.614C260.774 294.614 265.693 296.828 270.526 293.254C270.526 293.254 254.373 247.995 257.849 236.73Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M242.628 256.441C242.628 256.441 242.785 259.655 241.984 261.684C241.183 263.713 233.632 271.543 233.862 272.385C234.093 273.227 234.769 275.965 236.109 276.231",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M250.978 263.472C252.03 261.375 255.482 263.424 255.433 268.15",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M233.905 257.294C233.905 257.294 236.845 255.996 239.466 260.762",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M246.816 270.402C246.816 270.402 251.769 270.371 255.948 274.228",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M230.355 264.147C230.355 264.147 233.646 264.602 235.446 265.556",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M242.302 252.019C242.302 252.019 239.93 250.609 237.238 251.898C234.546 253.187 232.896 254.613 233.078 252.956C233.26 251.299 236.424 249.488 237.369 249.247C238.314 249.007 242.571 248.327 242.302 252.019Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M249.841 248.274C249.841 248.274 254.355 251.75 256.335 256.733C258.315 261.716 259.916 256.266 258.312 252.997C256.709 249.729 252.195 246.253 249.841 248.274Z",
    fill: "#263238"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M270.926 301.8C270.926 304.13 269.612 306.019 267.991 306.019C266.37 306.019 265.056 304.13 265.056 301.8C265.056 299.47 266.37 293.545 267.991 293.545C269.612 293.544 270.926 299.469 270.926 301.8Z",
    fill: "#40B0D5",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M251.261 262.562C251.153 262.85 251.06 263.164 250.992 263.502C250.698 264.982 250.409 268.074 251.044 268.2C251.678 268.326 252.995 265.438 253.289 263.959C253.35 263.653 253.381 263.359 253.394 263.077C252.656 262.848 251.913 262.682 251.261 262.562Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M234.205 257.022C234.119 257.271 234.042 257.534 233.986 257.817C233.692 259.297 233.701 262.548 234.335 262.674C234.969 262.8 235.989 259.753 236.283 258.273C236.359 257.89 236.396 257.52 236.399 257.179C235.589 256.962 234.847 256.943 234.205 257.022Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M251.022 263.516L251.999 261.655C251.999 261.655 254.579 262.085 256.084 264.02",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M234.205 257.022L235.229 255.85C235.229 255.85 235.659 255.635 238.024 256.71",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M230.408 284.119C230.408 284.119 232.093 281.03 234.339 281.03C236.585 281.03 238.27 286.084 238.27 286.084",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M158.041 417.382C155.515 417.382 152.789 416.331 151.739 415.881C150.633 415.407 150.121 414.126 150.595 413.02C151.07 411.915 152.351 411.403 153.456 411.876C155.469 412.734 158.05 413.258 158.746 412.961C160.007 411.538 161.963 402.922 159.437 398.818C158.874 397.902 158.343 397.734 157.993 397.686C156.563 397.489 154.44 398.963 153.689 399.664C152.809 400.484 151.431 400.438 150.61 399.558C149.789 398.678 149.836 397.299 150.716 396.478C151.116 396.105 154.731 392.847 158.575 393.368C159.88 393.544 161.734 394.237 163.148 396.534C166.866 402.576 164.316 414.092 161.468 416.371C160.536 417.115 159.314 417.382 158.041 417.382Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 393,
    width: 16,
    height: 25
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M158.041 417.382C155.515 417.382 152.789 416.331 151.739 415.881C150.633 415.407 150.121 414.126 150.595 413.02C151.07 411.915 152.351 411.403 153.456 411.876C155.469 412.734 158.05 413.258 158.746 412.961C160.007 411.538 161.963 402.922 159.437 398.818C158.874 397.902 158.343 397.734 157.993 397.686C156.563 397.489 154.44 398.963 153.689 399.664C152.809 400.484 151.431 400.438 150.61 399.558C149.789 398.678 149.836 397.299 150.716 396.478C151.116 396.105 154.731 392.847 158.575 393.368C159.88 393.544 161.734 394.237 163.148 396.534C166.866 402.576 164.316 414.092 161.468 416.371C160.536 417.115 159.314 417.382 158.041 417.382Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.934 398.157C160.015 396.39 158.81 395.857 157.962 395.721C155.463 395.32 153.113 397.827 152.854 398.113C152.354 398.665 152.294 399.532 152.637 400.197C153.018 400.12 153.384 399.947 153.689 399.662C154.439 398.962 156.563 397.488 157.993 397.684C158.343 397.732 158.874 397.9 159.437 398.816C161.963 402.92 160.007 411.536 158.746 412.959C158.051 413.256 155.469 412.732 153.456 411.874C153.202 411.765 152.938 411.714 152.677 411.705C152.737 412.277 153.039 412.797 153.519 413.04C154.202 413.386 155.974 414.195 157.615 414.195C158.442 414.195 159.237 413.99 159.842 413.416C161.693 411.665 163.35 402.805 160.934 398.157Z",
    fill: "#A3B1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 150,
    y: 393,
    width: 16,
    height: 25
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M158.041 417.382C155.515 417.382 152.789 416.331 151.739 415.881C150.633 415.407 150.121 414.126 150.595 413.02C151.07 411.915 152.351 411.403 153.456 411.876C155.469 412.734 158.05 413.258 158.746 412.961C160.007 411.538 161.963 402.922 159.437 398.818C158.874 397.902 158.343 397.734 157.993 397.686C156.563 397.489 154.44 398.963 153.689 399.664C152.809 400.484 151.431 400.438 150.61 399.558C149.789 398.678 149.836 397.299 150.716 396.478C151.116 396.105 154.731 392.847 158.575 393.368C159.88 393.544 161.734 394.237 163.148 396.534C166.866 402.576 164.316 414.092 161.468 416.371C160.536 417.115 159.314 417.382 158.041 417.382Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M160.934 398.157C160.015 396.39 158.81 395.857 157.962 395.721C155.463 395.32 153.113 397.827 152.854 398.113C152.354 398.665 152.294 399.532 152.637 400.197C153.018 400.12 153.384 399.947 153.689 399.662C154.439 398.962 156.563 397.488 157.993 397.684C158.343 397.732 158.874 397.9 159.437 398.816C161.963 402.92 160.007 411.536 158.746 412.959C158.051 413.256 155.469 412.732 153.456 411.874C153.202 411.765 152.938 411.714 152.677 411.705C152.737 412.277 153.039 412.797 153.519 413.04C154.202 413.386 155.974 414.195 157.615 414.195C158.442 414.195 159.237 413.99 159.842 413.416C161.693 411.665 163.35 402.805 160.934 398.157Z",
    fill: "white"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M158.041 417.382C155.515 417.382 152.789 416.331 151.739 415.881C150.633 415.407 150.121 414.126 150.595 413.02C151.07 411.915 152.351 411.403 153.456 411.876C155.469 412.734 158.05 413.258 158.746 412.961C160.007 411.538 161.963 402.922 159.437 398.818C158.874 397.902 158.343 397.734 157.993 397.686C156.563 397.489 154.44 398.963 153.689 399.664C152.809 400.484 151.431 400.438 150.61 399.558C149.789 398.678 149.836 397.299 150.716 396.478C151.116 396.105 154.731 392.847 158.575 393.368C159.88 393.544 161.734 394.237 163.148 396.534C166.866 402.576 164.316 414.092 161.468 416.371C160.536 417.115 159.314 417.382 158.041 417.382Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M154.183 391.58H130.131V423.504H154.183V391.58Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 391,
    width: 25,
    height: 33
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M154.183 391.58H130.131V423.504H154.183V391.58Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.983 391.58H130.131V423.504H139.983V391.58Z",
    fill: "#A3B1FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_914_22995",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 130,
    y: 391,
    width: 25,
    height: 33
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M154.183 391.58H130.131V423.504H154.183V391.58Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_914_22995)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M139.983 391.58H130.131V423.504H139.983V391.58Z",
    fill: "white"
  }))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M154.183 391.58H130.131V423.504H154.183V391.58Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M286.336 423.059H183.605L180.246 366.581C179.853 364.238 181.66 362.103 184.036 362.103H285.905C288.281 362.103 290.087 364.238 289.695 366.581L286.336 423.059Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M188.658 363.455H285.158C287.499 363.455 289.279 365.522 288.892 367.79",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M181.005 366.899C181.145 365.008 182.753 363.454 184.782 363.454",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M286.773 417.556H183.168V423.059H286.773V417.556Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M234.603 397.198C238.656 397.198 241.941 395.227 241.941 392.795C241.941 390.363 238.656 388.392 234.603 388.392C230.55 388.392 227.265 390.363 227.265 392.795C227.265 395.227 230.55 397.198 234.603 397.198Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M443.025 422.412H57.167V431.784H443.025V422.412Z",
    fill: "#263238"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M342.977 204.171H157.346C151.088 204.171 146.015 199.098 146.015 192.84V86.331C146.015 80.073 151.088 75 157.346 75H342.977C349.235 75 354.308 80.073 354.308 86.331V192.84C354.308 199.098 349.235 204.171 342.977 204.171Z",
    fill: "#40B0D5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M255.06 149.227C271.9 146.52 283.356 130.674 280.65 113.835C277.943 96.9952 262.097 85.5383 245.258 88.2451C228.418 90.9519 216.961 106.797 219.668 123.637C222.375 140.477 238.22 151.934 255.06 149.227Z",
    fill: "#263238"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M249.601 123.762L238.928 135.204C238.005 136.254 236.874 136.779 235.538 136.779C234.575 136.779 233.744 136.505 233.047 135.954C232.35 135.405 232 134.72 232 133.9C232 133.129 232.354 132.341 233.062 131.538L245.238 118.963L233.799 106.39C233.249 105.75 232.974 105.07 232.974 104.347C232.974 103.445 233.376 102.661 234.182 101.997C234.987 101.333 235.921 101 236.983 101C238.281 101 239.39 101.534 240.315 102.6L250.634 113.944L261.041 102.797C262.083 101.599 263.271 101 264.608 101C265.533 101 266.328 101.283 266.998 101.849C267.666 102.415 268 103.083 268 103.854C268 104.494 267.734 105.109 267.204 105.699L254.996 118.741L266.79 131.734C267.381 132.391 267.675 133.071 267.675 133.777C267.675 134.663 267.263 135.422 266.436 136.053C265.611 136.684 264.669 137 263.608 137C262.271 137 261.15 136.476 260.245 135.425L249.601 123.762Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M309.032 181.803H191.291C186.316 181.803 182.284 177.77 182.284 172.795C182.284 167.82 186.317 163.788 191.291 163.788H309.032C314.007 163.788 318.039 167.821 318.039 172.795C318.04 177.77 314.007 181.803 309.032 181.803Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M225.781 175.697C225.618 175.697 225.477 175.637 225.356 175.516C225.235 175.396 225.175 175.249 225.175 175.074C225.175 174.942 225.214 174.806 225.293 174.668L226.187 173.269L224.354 173.323C224.155 173.323 224.002 173.263 223.893 173.142C223.785 173.022 223.731 172.877 223.731 172.709C223.731 172.54 223.785 172.396 223.893 172.276C224.001 172.156 224.155 172.096 224.354 172.096L226.159 172.15L225.31 170.805C225.22 170.642 225.174 170.495 225.174 170.363C225.174 170.182 225.236 170.032 225.359 169.912C225.482 169.792 225.626 169.732 225.788 169.732C226.017 169.732 226.195 169.847 226.321 170.075L227.197 171.646L228.036 170.138C228.199 169.867 228.4 169.732 228.641 169.732C228.804 169.732 228.943 169.79 229.061 169.908C229.179 170.025 229.237 170.171 229.237 170.346C229.237 170.479 229.197 170.611 229.119 170.743L228.235 172.151L230.068 172.097C230.267 172.097 230.42 172.157 230.528 172.277C230.636 172.397 230.69 172.542 230.69 172.71C230.69 172.879 230.636 173.023 230.528 173.143C230.42 173.263 230.266 173.324 230.068 173.324L228.218 173.27L229.039 174.552C229.142 174.732 229.192 174.901 229.192 175.058C229.192 175.238 229.134 175.387 229.016 175.504C228.898 175.622 228.762 175.68 228.606 175.68C228.365 175.68 228.173 175.551 228.028 175.292L227.198 173.821L226.367 175.292C226.222 175.561 226.027 175.697 225.781 175.697Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M234.96 175.697C234.798 175.697 234.656 175.637 234.536 175.516C234.415 175.396 234.355 175.249 234.355 175.074C234.355 174.942 234.394 174.806 234.473 174.668L235.366 173.269L233.534 173.323C233.335 173.323 233.182 173.263 233.074 173.142C232.966 173.022 232.911 172.877 232.911 172.709C232.911 172.54 232.966 172.396 233.074 172.276C233.182 172.156 233.336 172.096 233.534 172.096L235.339 172.15L234.491 170.805C234.401 170.642 234.355 170.495 234.355 170.363C234.355 170.182 234.416 170.032 234.539 169.912C234.662 169.792 234.806 169.732 234.969 169.732C235.198 169.732 235.375 169.847 235.501 170.075L236.377 171.646L237.216 170.138C237.379 169.867 237.58 169.732 237.821 169.732C237.983 169.732 238.123 169.79 238.24 169.908C238.358 170.025 238.416 170.171 238.416 170.346C238.416 170.479 238.377 170.611 238.299 170.743L237.414 172.151L239.247 172.097C239.446 172.097 239.599 172.157 239.707 172.277C239.815 172.397 239.87 172.542 239.87 172.71C239.87 172.879 239.815 173.023 239.707 173.143C239.599 173.263 239.445 173.324 239.247 173.324L237.396 173.27L238.217 174.552C238.32 174.732 238.371 174.901 238.371 175.058C238.371 175.238 238.313 175.387 238.195 175.504C238.078 175.622 237.941 175.68 237.784 175.68C237.544 175.68 237.351 175.551 237.207 175.292L236.376 173.821L235.545 175.292C235.403 175.561 235.207 175.697 234.96 175.697Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M244.141 175.697C243.978 175.697 243.837 175.637 243.716 175.516C243.596 175.396 243.535 175.249 243.535 175.074C243.535 174.942 243.575 174.806 243.653 174.668L244.547 173.269L242.714 173.323C242.515 173.323 242.362 173.263 242.253 173.142C242.145 173.022 242.091 172.877 242.091 172.709C242.091 172.54 242.145 172.396 242.253 172.276C242.361 172.156 242.515 172.096 242.714 172.096L244.519 172.15L243.67 170.805C243.58 170.642 243.534 170.495 243.534 170.363C243.534 170.182 243.596 170.032 243.72 169.912C243.843 169.792 243.986 169.732 244.148 169.732C244.377 169.732 244.555 169.847 244.681 170.075L245.557 171.646L246.396 170.138C246.559 169.867 246.76 169.732 247.001 169.732C247.164 169.732 247.303 169.79 247.421 169.908C247.539 170.025 247.597 170.171 247.597 170.346C247.597 170.479 247.557 170.611 247.479 170.743L246.595 172.151L248.428 172.097C248.627 172.097 248.78 172.157 248.888 172.277C248.996 172.397 249.05 172.542 249.05 172.71C249.05 172.879 248.996 173.023 248.888 173.143C248.78 173.263 248.626 173.324 248.428 173.324L246.577 173.27L247.398 174.552C247.501 174.732 247.552 174.901 247.552 175.058C247.552 175.238 247.494 175.387 247.376 175.504C247.258 175.622 247.122 175.68 246.965 175.68C246.724 175.68 246.532 175.551 246.387 175.292L245.557 173.821L244.726 175.292C244.583 175.561 244.388 175.697 244.141 175.697Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M253.321 175.697C253.158 175.697 253.017 175.637 252.896 175.516C252.775 175.396 252.716 175.249 252.716 175.074C252.716 174.942 252.755 174.806 252.833 174.668L253.727 173.269L251.895 173.323C251.695 173.323 251.542 173.263 251.434 173.142C251.326 173.022 251.272 172.877 251.272 172.709C251.272 172.54 251.326 172.396 251.434 172.276C251.542 172.156 251.696 172.096 251.895 172.096L253.699 172.15L252.851 170.805C252.762 170.642 252.716 170.495 252.716 170.363C252.716 170.182 252.777 170.032 252.901 169.912C253.024 169.792 253.167 169.732 253.329 169.732C253.558 169.732 253.736 169.847 253.862 170.075L254.738 171.646L255.577 170.138C255.74 169.867 255.942 169.732 256.182 169.732C256.345 169.732 256.485 169.79 256.602 169.908C256.72 170.025 256.778 170.171 256.778 170.346C256.778 170.479 256.738 170.611 256.66 170.743L255.776 172.151L257.609 172.097C257.808 172.097 257.961 172.157 258.07 172.277C258.178 172.397 258.232 172.542 258.232 172.71C258.232 172.879 258.178 173.023 258.07 173.143C257.962 173.263 257.808 173.324 257.609 173.324L255.759 173.27L256.58 174.552C256.683 174.732 256.734 174.901 256.734 175.058C256.734 175.238 256.676 175.387 256.558 175.504C256.441 175.622 256.304 175.68 256.147 175.68C255.906 175.68 255.714 175.551 255.57 175.292L254.739 173.821L253.909 175.292C253.764 175.561 253.568 175.697 253.321 175.697Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M262.501 175.697C262.338 175.697 262.197 175.637 262.076 175.516C261.955 175.396 261.896 175.249 261.896 175.074C261.896 174.942 261.935 174.806 262.013 174.668L262.907 173.269L261.074 173.323C260.876 173.323 260.723 173.263 260.614 173.142C260.506 173.022 260.451 172.877 260.451 172.709C260.451 172.54 260.506 172.396 260.614 172.276C260.722 172.156 260.876 172.096 261.074 172.096L262.879 172.15L262.03 170.805C261.94 170.642 261.895 170.495 261.895 170.363C261.895 170.182 261.956 170.032 262.08 169.912C262.203 169.792 262.347 169.732 262.508 169.732C262.737 169.732 262.915 169.847 263.041 170.075L263.917 171.646L264.756 170.138C264.919 169.867 265.121 169.732 265.361 169.732C265.524 169.732 265.664 169.79 265.781 169.908C265.899 170.025 265.957 170.171 265.957 170.346C265.957 170.479 265.917 170.611 265.839 170.743L264.955 172.151L266.788 172.097C266.987 172.097 267.14 172.157 267.248 172.277C267.356 172.397 267.41 172.542 267.41 172.71C267.41 172.879 267.356 173.023 267.248 173.143C267.14 173.263 266.986 173.324 266.788 173.324L264.938 173.27L265.759 174.552C265.862 174.732 265.912 174.901 265.912 175.058C265.912 175.238 265.854 175.387 265.736 175.504C265.619 175.622 265.482 175.68 265.325 175.68C265.084 175.68 264.892 175.551 264.748 175.292L263.917 173.821L263.086 175.292C262.944 175.561 262.748 175.697 262.501 175.697Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M271.682 175.697C271.519 175.697 271.378 175.637 271.257 175.516C271.136 175.396 271.077 175.249 271.077 175.074C271.077 174.942 271.116 174.806 271.194 174.668L272.088 173.269L270.255 173.323C270.057 173.323 269.904 173.263 269.795 173.142C269.687 173.022 269.632 172.877 269.632 172.709C269.632 172.54 269.687 172.396 269.795 172.276C269.903 172.156 270.057 172.096 270.255 172.096L272.06 172.15L271.212 170.805C271.123 170.642 271.077 170.495 271.077 170.363C271.077 170.182 271.138 170.032 271.262 169.912C271.385 169.792 271.529 169.732 271.691 169.732C271.92 169.732 272.098 169.847 272.224 170.075L273.1 171.646L273.939 170.138C274.102 169.867 274.304 169.732 274.544 169.732C274.707 169.732 274.847 169.79 274.964 169.908C275.082 170.025 275.14 170.171 275.14 170.346C275.14 170.479 275.101 170.611 275.022 170.743L274.138 172.151L275.971 172.097C276.17 172.097 276.323 172.157 276.432 172.277C276.541 172.397 276.594 172.542 276.594 172.71C276.594 172.879 276.54 173.023 276.432 173.143C276.324 173.263 276.17 173.324 275.971 173.324L274.121 173.27L274.942 174.552C275.045 174.732 275.096 174.901 275.096 175.058C275.096 175.238 275.038 175.387 274.92 175.504C274.803 175.622 274.666 175.68 274.509 175.68C274.268 175.68 274.076 175.551 273.932 175.292L273.101 173.821L272.27 175.292C272.124 175.561 271.928 175.697 271.682 175.697Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M321.461 197.822H333.685",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M151.828 107.768V188.948C151.828 193.849 155.801 197.822 160.702 197.822H309.855",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M151.828 86.228V98.409",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.1d743106078b906c60ef759ee312ea0c.svg";
export { ForwardRef as ReactComponent };